import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { SVVH_LOGO } from "../constants/assets";

import Spinner from "../components/Spinner";

import { useTranslation } from "react-i18next";

import ThaiLifeBackButton from "../components/buttons/ThaiLifeBackButton";

import { getPageConfigField, getPartnerConfigField } from "../utils/getConfigs";

import { assetService } from "../services/assetService";
import { Partner, partnerService } from "../services/partnerService";

export default function Confirm() {
  const pageName = "confirm";

  const [isLoading, setIsLoading] = useState(false);

  const { t, i18n } = useTranslation();
  const i18nPath = "pages.confirm";

  const navigate = useNavigate();

  const handleStartCall = () => {
    setIsLoading(true);
    navigate("/call");
  };

  // configuration -----------------------------------------
  const isShowThaiLifeBackButton = getPageConfigField(
    pageName,
    "isShowThaiLifeBackButton"
  );
  const isShowBackButton = getPageConfigField(pageName, "isShowBackButton");
  const redirectUrl = getPartnerConfigField("redirectUrl");
  // -------------------------------------------------------

  const [logo, setLogo] = useState<string>();
  const [partner, setPartner] = useState<Partner | undefined>();
  const [stepsImg, setStepsImg] = useState<string>();

  const onMountedPartnerUx = () => {
    const partner = partnerService.getPartner();
    if (!partner) {
      navigate("/");
      return true;
    }
  };

  const onMountedPartnerUi = (currentPartner: Partner) => {
    if (currentPartner) {
      setPartner(currentPartner);

      // Set logo
      setLogo(assetService.getLogo(currentPartner.name));

      // Set steps.
      setStepsImg(assetService.getSteps(i18n.language));

      // Partner: ThaiLife.
      // isShowThaiLifeBackButton
    }
  };

  useEffect(() => {
    (async () => {
      const stop = await onMountedPartnerUx();
      if (stop) return;

      const currentPartner = partnerService.getPartner();
      if (currentPartner) {
        onMountedPartnerUi(currentPartner);
      }
    })();
  }, []);

  return (
    <div className="flex flex-col items-center p-4 md:p-10 gap-y-4 justify-center min-h-screen w-full">
      <div className="flex flex-col items-center gap-y-4 w-full">
        <div className="w-full max-w-2xl max-h-[750px] border p-10 rounded-3xl shadow-md bg-white items-center flex flex-col overflow-hidden">
          {isShowThaiLifeBackButton && (
            <div className="flex self-start">
              <ThaiLifeBackButton redirectUrl={redirectUrl} />
            </div>
          )}
          <div className="flex flex-col gap-y-1 justify-center items-center mb-4">
            <img
              src={logo || SVVH_LOGO}
              width={150}
              height={40}
              className="max-h-16 mb-7"
              alt="svvh-logo"
            />
            <div className="flex flex-col gap-y-[0.1px] text-center mb-3">
              <span className="text-svvh-green text-xl">
                {t(`${i18nPath}.texts.title1`)}
              </span>
              <span className="text-svvh-green text-xl">
                {t(`${i18nPath}.texts.title2`)}
              </span>
            </div>
          </div>

          <img
            src={stepsImg}
            className="w-full max-w-[300px] min-w-[260px]"
            alt="svvh-steps"
          />

          <button
            onClick={handleStartCall}
            disabled={isLoading}
            // className="px-4 py-2 rounded-3xl text-white w-[120px] bg-[#12663F] hover:bg-green-700 mt-4 flex items-center justify-center gap-2 disabled:bg-gray-400"
            className="px-4 py-2 rounded-3xl text-white w-[150px] h-12 gold-submit-btn mt-4 flex items-center justify-center gap-2 disabled:bg-gray-400"
          >
            {isLoading ? (
              <Spinner size="medium" color="white" />
            ) : (
              t(`${i18nPath}.buttons.call`)
            )}
          </button>

          {isShowBackButton && (
            <button
              onClick={() => {
                if (redirectUrl) {
                  window.location.href = redirectUrl;
                } else {
                  window.location.href = "/register?manual=true";
                }
              }}
              className="px-4 py-2 rounded-3xl text-svvh-green bg-white border border-svvh-green hover:bg-svvh-light-green w-[120px] mt-4"
            >
              {t(`${i18nPath}.buttons.back`)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
